<div class="loading-overlay" *ngIf="isLoading$ | async">
    <div class="loading-content">
      <div class="logo-container">
        <img [src]="logoPath" alt="Logo" class="base-logo">
        <div class="color-overlay"></div>
      </div>
    </div>
  </div>